const state = {
  auth: localStorage.getItem('access') !== null,
  authError: {},
};

export default state;
